export enum Role {
    ALUMNO = 'Alumno Escuela',
    CLUB = 'Club',
    AFILIADO = 'Afiliado',
    DEPORTISTA = 'DEPORTISTA',
    ENTRENADOR = 'ENTRENADOR',
    DELEGADO = 'DELEGADO',
    TECNICO = 'TECNICO'
}